import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class ReportXpressService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getTaxiOperationReport(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/ReportXpressDelivery/GetTaxiOperationReport', data, messageService);
    }

    public getTaxiRidershipReport(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/ReportXpressDelivery/GetTaxiRidershipReport', data, messageService);
    }

    public getTNVSReport(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/ReportXpressDelivery/GetTNVSReport', data, messageService);
    }

    public getOrdersByPromoReport(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/ReportXpressDelivery/GetOrdersByPromoReport', data, messageService);
    }

    public getDriverPerformanceReport(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/ReportXpressDelivery/GetDriverPerformanceReport', data, messageService);
    }

    public exportDriverPerformanceReport(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/ReportXpressDelivery/ExportDriverPerformanceReport', data, messageService);
    }

	public getTaxiDriversPerformanceReport(data: any, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/ReportXpressDelivery/GetTaxiDriversPerformanceReport', data, messageService);
	}

	public exportTaxiDriversPerformanceReport(data: any, messageService: MessageService): Promise<any> {
		return this.apiHttp.postDownloadFile('api/ReportXpressDelivery/ExportTaxiDriversPerformanceReport', data, messageService);
	}
}
